<template>
  <div>
    <v-expansion-panels flat multiline>
      <v-expansion-panel>
        <v-expansion-panel-header :id="`${instanceType}-instance-panel-expand`">
          <span class="file-type">{{ instanceType }}</span>
          <template v-slot:actions>
            <AddInstanceDialog
              v-if="getCurrentUserIsAbleToWrite('dsrcInstance')"
              :datFiles="dats.filter(dat => !dat.validTo)"
              :fileType="instanceType"
              :fileTotal="instances.length"
              :activefileCount="instances.filter(instance => instance.activated).length"
              :masterAccount="masterAccount"
              @addInstance="addInstance($event)"
            />
            <v-icon id="instance-expand-button"> $expand </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <VersionPanelContainer
            v-for="instance in instances"
            :key="instance.eid"
            :instance="instance"
            :masterAccount="masterAccount"
            @updateList="updateList"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MasterAccountInfo } from 'ctp-user-auth-service';
import { DatRelatedV3, InstanceRelated } from 'ctp-toll-domain';
import { store as userPermissionStore } from '@/store/modules/permissions/types';
import { INotification, store as datInstanceStore } from '@/store/modules/datInstances/types';
import AddInstanceDialog from './AddInstanceDialog.vue';
import VersionPanelContainer from './VersionPanelContainer.vue';

@Component({
  components: {
    AddInstanceDialog,
    VersionPanelContainer
  }
})
export default class VersionPanel extends Vue {
    @Prop()
    private instances!: InstanceRelated[];

    @Prop()
    private instanceType!: string;

    @Prop()
    private masterAccount!: MasterAccountInfo;

    @Prop()
    private dats!: DatRelatedV3[];

    @datInstanceStore.Action
    private createDatInstance!: (payload: any) => Promise<INotification>;

    private async addInstance(filedata: InstanceRelated) {
      await this.createDatInstance(filedata);
      this.$emit('updateList');
    }

    @userPermissionStore.Getter
    private getCurrentUserIsAbleTo: (readOrWrite: string, featureName: string) => boolean;

    private getCurrentUserIsAbleToWrite(featureName: string) {
      return featureName ? this.getCurrentUserIsAbleTo('write', featureName) : false;
    }

    private updateList() {
      this.$emit('updateList');
    }
}
</script>

<style lang="scss" scoped>
@import './styles/version-panel.scss';
</style>
